import { html, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";

import { config } from "../../modules/config";
import { getAssetUrl } from "../../utils/url";

import styles from "./logo.css";

@customElement("bp-logo")
export class Logo extends LitElement {
  static styles = styles;

  @property()
  lang: "en" | "es" = config.language as "en" | "es";

  @property()
  title: string = "BibleProject Logo";

  @property()
  variant: "default" | "logo-mark" | "word-mark" = "default";

  get src() {
    switch (this.variant) {
      case "logo-mark":
        return getAssetUrl("/bibleproject-logo-mark.svg");
      case "word-mark":
        if (this.lang === "es") {
          return getAssetUrl("/proyectobiblia-word-mark.svg");
        }

        return getAssetUrl("/bibleproject-word-mark.svg");
      default:
        if (this.lang === "es") {
          return "/proyectobiblia.svg";
        }

        return getAssetUrl("/bibleproject.svg");
    }
  }

  render() {
    return html`
      <img
        src="${this.src}"
        style="height: var(--height);"
        title="${this.title}"
      />
    `;
  }
}
